// v6 Fase E1 — Derive room defaults from an active template (sticky context).
//
// Given an active Template (with template_lines + price codes), produce an
// array of "action" objects matching the shape used by ROOM_DEFAULTS so the
// existing RoomQuickFlow checklist UI works unchanged.
//
// Heuristic for auto_kind (drives auto-quantity from L/B/H):
//   unit=m2:
//     "plafond"                                                  → ceiling (L×W)
//     "vloer"                                                    → floor   (L×W)
//     otherwise                                                  → walls   (2(L+W)×H)
//   unit=lm:
//     "plinten" (alleen)                                         → plinten (2(L+W))
//     otherwise (incl. trapleuning, balustrade, lijsten, ...)    → linear  (manual)
//   v6 F9.1 — Trap-codes (T-*) blijven altijd manueel (linear) ook al
//   bevat de omschrijving toevallig "trapleun" of "plint"; de lengte van een
//   leuning of trapwang volgt niet uit de kamer-perimeter.
//   unit=piece                                                   → piece   (manual stepper)
//   unit=hour                                                    → hour    (manual)
//   unit=fixed                                                   → fixed   (qty=1)
//
// `default_checked` is read directly from TemplateLine.

export function deriveRoomDefaultsFromTemplate(template, priceCodes) {
  if (!template || !Array.isArray(template.template_lines)) return null;
  const codeById = new Map(priceCodes.map((p) => [p.id, p]));
  const actions = [];
  for (const ln of template.template_lines) {
    const pc = codeById.get(ln.price_code_id);
    if (!pc) continue;
    const unit = pc.unit || "m2";
    const desc = (ln.description_override || pc.description || "").toLowerCase();
    const code = (pc.code || "").toUpperCase();
    let auto_kind;
    // v6 F9.1 — Trap-codes (T-*) zijn altijd manuele invoer (lm / m² / uur /
    // forfait). Hun hoeveelheid volgt nooit uit de kamer-afmetingen.
    const isTrapCode = code.startsWith("T-");
    if (unit === "lm") {
      if (isTrapCode) auto_kind = "linear";
      else auto_kind = /plinten/.test(desc) ? "plinten" : "linear";
    } else if (unit === "piece") {
      auto_kind = "piece";
    } else if (unit === "hour") {
      auto_kind = "hour";
    } else if (unit === "fixed") {
      auto_kind = "fixed";
    } else {
      // m² (default)
      // v6 F9.1 — Trap-objectcodes (T-03.04 Overloop, T-03.05 Onderzijde) zijn
      // losse m²-vlakken die niet automatisch uit kamer L×W×H volgen.
      // Markeer ze als "manual" zodat de gebruiker zelf m² kan invoeren.
      if (isTrapCode) auto_kind = "manual";
      else if (/plafond/.test(desc)) auto_kind = "ceiling";
      else if (/vloer/.test(desc)) auto_kind = "floor";
      else auto_kind = "walls";
    }
    actions.push({
      code: pc.code,
      label: ln.description_override || pc.description,
      auto_kind,
      default_checked: !!ln.default_checked,
      // v6 F42k Correctieronde v8 — Choice-group voor exclusieve alternatieven
      // (schuurgraad, plamuurwerk, plaatselijk_herstel, spuit_schuren, ...).
      choice_group: ln.choice_group || null,
    });
  }
  return actions;
}
